import React from 'react';
import { IntlShape, useIntl } from 'react-intl';
import cn from 'classnames';
import { Header, NavBar, headerNavigationRegistration } from '@marketplace/common';
import { New_footer as SimpleFooter } from '../../../pages/layouts/landing-layout/footer/footer';
import { Logo } from '@marketplace/ui-elements';

import classes from './completion.module.scss';

export const Completion = () => {
  const { formatMessage }: IntlShape = useIntl();

  return (
    <div className={classes.registrationRoot}>
      <Header
        logo={<Logo subLogo={formatMessage({ id: 'developer_landing_header_sub_logo' })} />}
        leftSection={<NavBar options={headerNavigationRegistration} />}
      />
      <div className={classes.confirmationForm}>
        <div className={classes.root} id="registration-completion-form">
          <div className={classes.iconWrapper}>
            <i className={cn('pi pi-check-circle', classes.icon)} />
          </div>
          <h2>{formatMessage({ id: 'registrationCompletion_title' })}</h2>
          <div className={classes.message}>{formatMessage({ id: 'registrationCompletion_message' })}</div>
        </div>
      </div>
      <div className={classes.registrationFooter}>
        <SimpleFooter />
      </div>
    </div>
  );
};
